import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// Servicios core
import { AuthService } from '../auth.service';
import { AuthHttpInterceptorService } from '@pages/authentication/services/auth-http-interceptor.service';
import { NewAuthHttpInterceptorService } from '@pages/authentication/services/new-auth-http-interceptor.service';
import { CryptDataService } from '@shared/utils/crypt-data.service';
import { PermissionsService } from '@shared/utils/permissions/permissions.service';
import { UserService } from '@pages/user/services/user.service';
import { HelpersService } from '@shared/helpers/helpers.service';
import { LogService } from '@shared/services/Log/log.service';

// Guards
import { ValidateTokenGuard } from '../guards/validate-token.guard';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  providers: [
    AuthService,
    CryptDataService,
    PermissionsService,
    UserService,
    HelpersService,
    LogService,
    ValidateTokenGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NewAuthHttpInterceptorService,
      multi: true
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule ya está cargado. Solo debe importarse en AppModule.');
    }
  }
}
